import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ExampleContent, ExampleImg, ExampleText, ExampleTitle, ExampleWrapper } from './StyledExample';

function ExampleCard({ src, title, description, link }) {
    return (
        <Link to={link} >
            <ExampleWrapper>
                <Col md={3}>
                    <ExampleImg src={src} alt="example-pic" />
                </Col>
                <Col md={9}>
                    <ExampleContent>
                        <ExampleTitle>{title}</ExampleTitle>
                        <ExampleText>
                            {description}
                        </ExampleText>
                    </ExampleContent>
                </Col>
            </ExampleWrapper>
        </Link>
    )
}

export default ExampleCard
